<div class="checkboxGroup" [formGroup]="field.control" [transform]="toDbModel.bind(this)">
  <h3>{{ field.key | translate }}</h3>
  <div class="checkboxes">
    <ng-container *ngFor="let checkBox of Object.keys(checkboxTexts)">
      <mat-checkbox formControlName={{checkBox}}>
        {{ checkboxTexts[checkBox] | translate }}
      </mat-checkbox>
    </ng-container>
  </div>
</div>
